import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";

/**
 * Loads rows from a Supabase table ordered by a column.
 * Reused by every admin management module.
 */
export function useTableData<T extends { id: string }>(table: string, orderColumn = "orden") {
  const [rows, setRows] = useState<T[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const { data, error: queryError } = await supabase
        .from(table)
        .select("*")
        .order(orderColumn, { ascending: true });
      if (queryError) throw queryError;
      setRows((data as T[]) ?? []);
    } catch {
      setError("No pudimos cargar la información. Revisa tu conexión e intenta nuevamente.");
    } finally {
      setLoading(false);
    }
  }, [table, orderColumn]);

  useEffect(() => {
    void load();
  }, [load]);

  return { rows, setRows, loading, error, reload: load };
}